import { Directive, Injector, OnInit, Optional } from '@angular/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import { TableComponent } from '../table.component';
import { isUndefined } from 'lodash-es';
import { toBoolean } from '@wm/core';

const DEFAULT_CLS = '';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-table-action',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmTableAction]',
  providers: [
    provideAsWidgetRef(TableActionDirective)
  ],
  standalone: true,
  exportAs: 'wmTableAction'
})
export class TableActionDirective extends StylableComponent implements OnInit {
  static initializeProps = register('wm-table-action');

  accessroles: any;
  action: any;
  caption: string;
  class: string;
  disabled: boolean;
  displayName: string;
  icon: any;
  iconclass: string;
  position: any;
  shortcutkey: any;
  show: boolean;
  tabindex: any;
  title: string;
  key: any;
  hyperlink: string;
  target: string;
  buttonDef: any;
  conditionalclass: any;
  conditionalstyle: any;
  bindconditionalclass: string;
  bindconditionalstyle: string;

  private _propsInitialized: boolean;
  private binddisplayName: string | null;
  private bindtitle: string | null;
  constructor(inj: Injector, @Optional() viewParent: Parent, @Optional() public table: TableComponent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  populateAction() {
    this.buttonDef = {
      key: this.nativeElement.getAttribute('key'),
      displayName: this.getBoundVal('display-name') || this.nativeElement.getAttribute('display-name'),
      show:  ['true', 'false'].includes(this.getBoundVal('show') || '') ? toBoolean(this.getBoundVal('show')): this.getBoundVal('show'),
      class: this.nativeElement.getAttribute('class'),
      iconclass: this.nativeElement.getAttribute('iconclass'),
      title: this.getBoundVal('title') || this.nativeElement.getAttribute('title') || this.nativeElement.getAttribute('display-name'),
      action: this.nativeElement.getAttribute('action'),
      accessroles: this.nativeElement.getAttribute('accessroles'),
      shortcutkey: this.nativeElement.getAttribute('shortcutkey'),
      disabled: ['true', 'false'].includes(this.getBoundVal('disabled') || '') ? toBoolean(this.getBoundVal('disabled')) : this.getBoundVal('disabled') || false,
      tabindex: this.nativeElement.getAttribute('tabindex'),
      icon: this.nativeElement.getAttribute('icon'),
      position: this.nativeElement.getAttribute('position') || 'footer',
      widgetType: this.nativeElement.getAttribute('widget-type'),
      hyperlink: this.nativeElement.getAttribute('hyperlink'),
      target: this.nativeElement.getAttribute('target')
    };
    let conditionalCls = this.bindconditionalclass || this.nativeElement.getAttribute('conditionalclass') || this.nativeElement.getAttribute('conditionalclass.bind') || '';
    if (conditionalCls) {
      this.buttonDef['conditionalclass'] = conditionalCls;
    }
    let conditionalstyle = this.bindconditionalstyle || this.nativeElement.getAttribute('conditionalstyle') || this.nativeElement.getAttribute('conditionalstyle.bind');
    if (conditionalstyle) {
      this.buttonDef['conditionalstyle'] = conditionalstyle;
    }
    this._propsInitialized = true;
  }

  getBoundVal(prop: string) {
    let propName = prop + '.bind';
    let val = this.nativeElement.getAttribute(propName);
    if (val && val !== 'null') {
      return ('bind:' + val);
    }
    return this.nativeElement.getAttribute(prop) || null;
  }

  override ngOnInit() {
    super.ngOnInit();
    this.populateAction();
    this.table.registerActions(this.buttonDef);
  }

  override onPropertyChange(key: any, nv: any) {
    if (!this._propsInitialized) {
      return;
    }

    if (key === 'display-name') {
      this.buttonDef.displayName = nv;
    } else {
      this.buttonDef[key] = nv;
    }
  }
}

